import React, { useState, useEffect, useContext } from 'react'
import { LocalizationContext } from '../../../shared/contexts'
import { formatTenantDateTime } from '../../../../utils/formatTenantDateTime'
import axios from 'axios'
import { Box, CircularProgress, Typography, Chip } from '@mui/material'

import { TIME_SOURCE, timeSourceTitle } from '../../../../utils/timeSource'

interface SentryAlertRow {
  id: number
  level: string
  message: string
  sent_at: string
}

const levelChipColor = (level: string): 'default' | 'info' | 'warning' | 'error' => {
  if (level === 'error' || level === 'fatal') return 'error'
  if (level === 'warning') return 'warning'
  if (level === 'info') return 'info'
  return 'default'
}

const SentryAlertsSection = ({ basePath }: { basePath: string }) => {
  const [rows, setRows] = useState<SentryAlertRow[] | null>(null)
  const [loading, setLoading] = useState(true)
  const localization = useContext(LocalizationContext)
  const formatDateTime = (value: string | null) => formatTenantDateTime(value, localization)

  useEffect(() => {
    axios.get(`${basePath}/sentry_alerts`)
      .then(({ data }) => {
        setRows(data)
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [basePath])

  if (loading) {
    return <Box className='text-center py-3'><CircularProgress size={24} /></Box>
  }

  if (!rows || rows.length === 0) {
    return <Typography variant='body2' color='text.secondary'>No alerts related to this order.</Typography>
  }

  return (
    <table className='table table-robis order-show-sentry-table'>
      <thead className='thead-robis'>
        <tr>
          <th>Level</th>
          <th>Message</th>
          <th>Sent at</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td><Chip label={row.level} color={levelChipColor(row.level)} size='small' /></td>
            <td className='sentry-alert-message-cell'>{row.message}</td>
            <td title={timeSourceTitle(row.sent_at, TIME_SOURCE.app)}>{formatDateTime(row.sent_at)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default SentryAlertsSection
